<template>
    <section-wrapper
        :class="Section.THEME.cssClassName"
        :this-section="Section.THEME"
        :next-section="isInEditMode ? null : Section.INVESTMENT_PROPOSAL"
        :section-end-button-label="$t('modelPortfolioDetails.sectionEndButtonLabel')"
        :section-end-button-is-disabled="!isModelPortfolioAvailable"
        :section-end-button-in-dom="!isInEditMode">
        <theme-overview />
        <other-investments />
        <model-portfolio-details />

        <!-- Edit Mode Options -->
        <edit-mode-buttons />
    </section-wrapper>
</template>

<script>
import ThemeOverview from '@/components/ThemeOverview';
import OtherInvestments from '@/modules/theme-details/OtherInvestments';
import ModelPortfolioDetails from '@/components/ModelPortfolioDetails';
import SectionWrapper from '@/components/common/SectionWrapper';
import EditModeButtons from '@/components/EditModeButtons';
import { Section } from '@/enums';
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
    name: 'Theme',
    components: {
        ThemeOverview,
        OtherInvestments,
        ModelPortfolioDetails,
        SectionWrapper,
        EditModeButtons,
    },
    data () {
        return {
            Section,
        };
    },
    computed: {
        ...mapGetters([
            'isInEditMode',
            'isModelPortfolioAvailable',
        ]),
        ...mapState([
            'investmentTopic',
            'investmentRegion',
            'otherInvestments',
        ]),
    },
    methods: {
        ...mapActions([
            'setLastOpenSection',
            'fetchModelPortfolioPositions',
            'fetchModelPortfolioDetails',
        ]),
        setThemeAsLastOpenSection () {
            this.setLastOpenSection(Section.THEME);
        },
        handleSelectionChange () {
            this.fetchModelPortfolioPositions();
            this.fetchModelPortfolioDetails();
            this.setThemeAsLastOpenSection();
        },
    },
    watch: {
        investmentTopic (newTopic, oldTopic) {
            this.handleSelectionChange();
        },
        investmentRegion (newRegion, oldRegion) {
            this.handleSelectionChange();
        },
        otherInvestments (newInvestment, oldInvestment) {
            this.handleSelectionChange();
        },
    },
};
</script>
